import React, { ReactElement } from 'react';

import './ProgressLoadingBar.css';

export type ProgressLoadingBarProps = {
  progress?: number;
};
/**
 * A React component that renders a loading progress bar.
 * If progress is not provided, it will render an infinite loading bar
 * If progress is provided, it will render a progress bar
 * The progress text can be optionally displayed to the left of the bar.
 */
function ProgressLoadingBar({ progress }: ProgressLoadingBarProps): ReactElement {
  return (
    <div className="loading">
      {progress === undefined || progress === null ? (
        <div className="infinite-loading-bar bg-[#c93a4c]"></div>
      ) : (
        <div
          className="bg-[#c93a4c]"
          style={{
            width: `${progress}%`,
            height: '2px',
          }}
        ></div>
      )}
    </div>
  );
}

export default ProgressLoadingBar;
